module.exports = __webpack_public_path__ + "img/car_icon14.fb5c3dd6.png";